//import Libraries
import React, { Component } from 'react';
import { Route, BrowserRouter } from 'react-router-dom';
import {connect} from 'react-redux';

import firebase from 'firebase';

//import Components
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Engineering from './pages/Engineering/Engineering';
import Product from './pages/Product/Product';
import Store from './pages/Store/Store';
import Community from './pages/Community/Community';
import Admin from './pages/Admin/Admin'
import MyPage from './pages/MyPage/MyPage';
import Cart from './pages/Cart/Cart';

//import Actions
import * as loginActions from './loginActions';
import * as cartActions from './pages/Store/actions/cartActions';

//import Style classes

class App extends Component {

  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
      if(user){
        this.props.onLoggedIn(user);
     }else {
        this.props.onLoggedOut();
      }
    })
  }

  
  render () {
    if(!this.props.user) {
      return (
        <div>
        </div>
      )
    }
    return (
        <BrowserRouter>
          <div className="App">
            <Route path="/" exact component={Home} />
            <Route path="/about" exact component={About} />
            <Route path="/engineering" exact component={Engineering} />
            <Route path="/engineering/:page" component={Engineering} />
            <Route path="/products/" exact component={Product} />
            <Route path="/products/:page" exact component={Product} />
            <Route path="/store" exact component={Store} />
            <Route path="/community" exact component={Community} />
            <Route path="/admin" exact component={Admin} />
            <Route path="/mypage" exact component={MyPage} />
          </div>
        </BrowserRouter>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user : state.user
  }
}

const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    onLoggedIn: (user) => {
      dispatch(loginActions.loggedIn(user));
    },
    onLoggedOut: () => {
      dispatch(loginActions.loggedOut());
    },
    onClearCartInReducer : () => {
      dispatch(cartActions.clearCartInReducer());
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/App.js